import React from 'react';

export default function DateRangePicker({ fromDate, toDate, onFromChange, onToChange }) {
  return (
    <div className="flex space-x-2">
      <input
        type="date"
        value={fromDate}
        onChange={(e) => onFromChange(e.target.value)}
        className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
        placeholder="From"
      />
      <span className="text-gray-400 self-center">→</span>
      <input
        type="date"
        value={toDate}
        onChange={(e) => onToChange(e.target.value)}
        className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
        placeholder="To"
      />
    </div>
  );
}
